import { getExamsProtocols } from "@/services/utilityService";

export default {
  state: {
    procedure: {},
    occupation: {},
    protocol: {},
    updateProtocol: false,
    statusList: false,
    bindData: {},
    statusBindModal: false,

    examsProtocols: [],
  },

  getters: {
    getProcedureData(state) {
      return state.procedure;
    },

    getOccupationData(state) {
      return state.occupation;
    },

    getProtocolData2(state) {
      return state.protocol;
    },

    getUpdateProtocolStatus(state) {
      return state.updateProtocol;
    },

    getStatusList(state) {
      return state.statusList;
    },

    getBindData(state) {
      return state.bindData;
    },

    getStatusBindModal(state) {
      return state.statusBindModal;
    },

    getExamsProtocols(state) {
      return state.examsProtocols;
    },
  },

  mutations: {
    setProcedureData(state, data) {
      state.procedure = data;
    },

    setOccupationData(state, data) {
      state.occupation = data;
    },

    setProtocolData(state, data) {
      const isUpdate = Object.keys(data).length > 0;
      state.updateProtocol = isUpdate;

      state.protocol = {
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        mandatory: isUpdate ? parseInt(data.flag_required) : "",
        observation: isUpdate ? data.observation : "",
      };
    },

    setProtocolList(state) {
      state.statusList = !state.statusList;
    },

    setBindData(state, data) {
      state.bindData = data;
      state.statusBindModal = !state.statusBindModal;
    },

    async setExamsProtocols(state) {
      const requestResponse = await getExamsProtocols();

      if (requestResponse.status) {
        state.examsProtocols = requestResponse.response;
      }
    },
  },

  actions: {
    changeProcedureData(context, data) {
      context.commit("setProcedureData", data);
    },

    changeOccupationData(context, data) {
      context.commit("setOccupationData", data);
    },

    changeProtocolData(context, data) {
      context.commit("setProtocolData", data);
    },

    changeProtocolList(context, data) {
      context.commit("setProtocolList", data);
    },

    changeBindData(context, data) {
      context.commit("setBindData", data);
    },

    changeExamsProtocols(context) {
      context.commit("setExamsProtocols");
    },
  },
};
